var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "VueTables__no-results" }, [
    _c(
      "td",
      {
        staticClass: "text-center",
        attrs: { tabindex: _vm.props.tabIndex, colspan: _vm.props.colspan },
      },
      [
        _c("img", {
          staticClass: "d-block",
          staticStyle: {
            height: "4em",
            width: "auto",
            "max-height": "unset",
            "max-width": "unset",
            margin: "0 auto",
          },
          attrs: {
            height: "2em",
            src: require("@Shared/@Assets/img/application-missing.png"),
            alt: _vm.$t("global.phrases.noResultsFound"),
          },
        }),
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.props.display(_vm.props.loading ? "loading" : "noResults")
            ) +
            "\n  "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }